import { render, staticRenderFns } from "./RecentPodcasts.vue?vue&type=template&id=2262f9af"
import script from "./RecentPodcasts.vue?vue&type=script&lang=js"
export * from "./RecentPodcasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports